module.exports = __webpack_public_path__ + "static/img/automated-wiring_256.1cd1f7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/automated-wiring_256.png
// module id = Ciz0
// module chunks = 0